const sectionStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 10px 25px rgba(0,0,0,0.08)"
    : "none";
  e.currentTarget.style.transform = enter
    ? "translateY(-2px)"
    : "translateY(0)";
};

const Optimization = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "42px", marginBottom: "20px" }}>
          Optimization & Maintenance
        </h1>

        <p style={{ fontSize: "20px", color: "#555", maxWidth: "700px" }}>
          Improve performance, reduce AWS costs, and stabilize complex production systems.
          From infrastructure and architecture to code and data pipelines.
        </p>

        <div style={{ marginTop: "30px" }}>
          <a href="/contact" style={{
            padding: "14px 28px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none"
          }}>
            Optimize My System
          </a>
        </div>
      </div>


      {/* PROBLEMS (UPGRADED) */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>Common Problems</h2>

        <div style={gridStyle}>
          {[
            "High AWS costs caused by inefficient architecture or over-provisioning",
            "Performance bottlenecks in distributed or microservices systems",
            "Unstable systems with poor fault tolerance",
            "Over-engineered or overly complex architectures",
            "Lack of observability (logging, tracing, monitoring)",
            "Inefficient CI/CD pipelines slowing down delivery",
            "Data processing inefficiencies and slow pipelines",
            "Legacy systems limiting scalability and evolution"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* WHAT I OPTIMIZE (NEW 🔥) */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>What I Optimize</h2>

        <div style={gridStyle}>
          {[
            "Cloud architecture (serverless, containers, microservices)",
            "Application performance (Java, Python backends)",
            "Database performance and query efficiency",
            "Data pipelines and ETL workflows",
            "Event-driven systems and asynchronous processing",
            "CI/CD pipelines and development workflows",
            "Infrastructure as Code (CloudFormation, Terraform)",
            "Monitoring, logging, and observability systems"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* IMPROVEMENTS (UPGRADED) */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>What I Improve</h2>

        <div style={gridStyle}>
          {[
            "Cost optimization (right-sizing, architectural redesign)",
            "Performance tuning across application and infrastructure layers",
            "Refactoring and simplification of complex systems",
            "Reliability and fault tolerance improvements",
            "Observability (CloudWatch, tracing, logging)",
            "Security improvements and best practices",
            "Scalability and load handling",
            "Deployment speed and CI/CD efficiency"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* APPROACH (UPGRADED) */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>Approach</h2>

        <div style={gridStyle}>
          {[
            "Analyze system architecture, infrastructure, and usage patterns",
            "Identify bottlenecks across application, data, and infrastructure layers",
            "Evaluate cost drivers and inefficiencies",
            "Propose optimization strategies and architectural improvements",
            "Prioritize changes based on impact and effort",
            "Implement improvements or guide your team",
            "Validate improvements with metrics and monitoring",
            "Establish long-term best practices and standards"
          ].map((step, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              <strong>Step {i + 1}:</strong> {step}
            </div>
          ))}
        </div>
      </div>


      {/* CAPABILITIES (NEW 🔥) */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>Optimization Capabilities</h2>

        <div style={gridStyle}>
          {[
            "Serverless cost and performance optimization",
            "Container (ECS/EKS) resource tuning",
            "Database optimization (SQL, NoSQL)",
            "Event-driven architecture optimization",
            "High-availability and fault-tolerant system design",
            "CI/CD pipeline optimization and automation",
            "Observability and monitoring design",
            "Cloud migration and modernization strategies"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* OUTCOME (UPGRADED) */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>Outcome</h2>

        <div style={gridStyle}>
          {[
            "Significantly reduced AWS costs",
            "Faster and more reliable systems",
            "Improved scalability and performance",
            "Better system observability and control",
            "Simplified and maintainable architecture",
            "Faster development and deployment cycles",
            "Increased system stability in production",
            "Clear long-term architecture strategy"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>

        {/* FINAL CTA */}
        <div style={{
        textAlign: "center",
        margin: "100px 0",
        padding: "60px 20px",
        background: "#fafafa"
        }}>
        <h2 style={{
            fontSize: "32px",
            marginBottom: "16px"
        }}>
            Improve your AWS system
        </h2>

        <p style={{
            color: "#555",
            fontSize: "18px",
            marginBottom: "32px",
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto",
            lineHeight: "1.6"
        }}>
            Let’s analyze your system and identify the highest-impact improvements.
        </p>

        <a href="/contact" style={{
            display: "inline-block",
            padding: "16px 36px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            fontSize: "16px",
            transition: "all 0.2s ease",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
        }}
        >
            Get Started
        </a>
        </div>      

    </div>
  );
};

export default Optimization;